import { ReadArticlesManager } from '@core/ts/components/zork/readArticlesManager';
import { RelatedArticlesRenderer } from '@core/ts/components/related-articles/RelatedArticlesRenderer';
import VisibilityObserverService from '@core/ts/services/VisibilityObserverService';
import { initArticleReadingProgress } from '@core/ts/components/article-reading-progress/articleReadingProgress';
/**
 * Хук страницы ARTICLE для проекта "metalcutting".
 *
 * Отличия от дефолтного core-хука:
 *  - Code viewer (TabManager / ModalManager) отключён — на сайте нет кодовых вставок.
 *  - codeBlockContentCache не инициализируется.
 *
 * Сохранено:
 *  - Отслеживание прочитанных статей и UI серий.
 *  - Отложенная загрузка блока «Похожие статьи».
 */
export default async function onArticle(context) {
    const { currentArticleId } = context;
    const readArticlesManager = new ReadArticlesManager(currentArticleId);
    readArticlesManager.markCurrentArticleAsRead();
    readArticlesManager.updateSeriesArticlesUI();
    readArticlesManager.updateSeriesBottomUI();
    const relatedRenderer = new RelatedArticlesRenderer();
    const relatedBlock = document.getElementById('related-articles-skeleton');
    if (relatedBlock) {
        VisibilityObserverService.getInstance().observe(relatedBlock, (entry) => {
            if (entry.isIntersecting) {
                relatedRenderer.render(currentArticleId);
                VisibilityObserverService.getInstance().unobserve(relatedBlock);
            }
        });
    }
    initArticleReadingProgress();
}
